import {ServicesIntegrations} from './ServicesIntegrations';
export default ServicesIntegrations;